import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CompanyAPIService } from 'app/api/company.api.service';
import { AppState } from 'app/reducers';
import { parseErrorMessage } from 'app/utils/callstate';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { CompaniesActions } from '../actions';
import { CompaniesUISelectors } from '../selectors';

@Injectable()
export class CompaniesEffects {

    loadCompanies$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CompaniesActions.companiesRequested),
            withLatestFrom(this.store.select(CompaniesUISelectors.selectFilter)),
            switchMap(([_, companyFilter]) =>
                this.companyApiService
                    .Companies(companyFilter)
                    .pipe(
                        map(({ items: companies }) => CompaniesActions.companiesLoaded({ companies })),
                        catchError(error => of(CompaniesActions.companiesCancelled({
                            errorMessage: parseErrorMessage(error)
                        })))
                    )
            )
        )
    );    

    constructor(
        private actions$: Actions,
        private store: Store<AppState>,
        private companyApiService: CompanyAPIService,
    ) {}
}
